import { IAppUi, IAppSession, IAppGlobalConfig, ISesion } from './app.store.interface';

export class Sesion implements ISesion {
  UODes = null;
  UOJer = null;
  UOVer = null;
  Id = 0;
  Name = null;
  TDoc = null;
  NDoc = null;
  UOrg = null;
  iss = null;
  sub = null;
  email = null;
  jti = null;
  iat = null;
  nbf = null;
  exp = null;
  aud = null;
  TPais = null;
  Pais = null;
  fK_eIdArea = null;
  TPerfil = null;
  TTipoUsuario = null;
  TRepresentante = null;

  TTipoEmpresa = null;
  registroMTC = null;
  domicilio = null;
  telefono = null;
  representante = null;
  tipDocRepresentante = null;
  numDocRepresentante = null;
  celularRepre = null;
  emailRepre = null
}

export class AppStoreModel {

  ui: IAppUi = {
    //appTitle: { full: 'Sistema de Notificaciones Electrónicas', mini: 'SNE' },
    drawerMini: false,
    isMobile: false,
    drawerOpen: false,
    drawerMobileOpen: false,    
    isLoading: false,
    appMenu: [
      // {
      //   label: 'Demo',
      //   icon: 'offline_pin',
      //   items: [
      //     {
      //       label: 'Tablas',
      //       link: '/demo/tablas',
      //       icon: 'offline_pin',
      //     },
      //     {
      //       label: 'Botones',
      //       link: '/demo/botones',
      //       icon: 'offline_pin',
      //     },
      //     {
      //       label: 'Crud',
      //       link: '/demo/crud',
      //       icon: 'offline_pin',
      //     },
      //     {
      //       label: 'Tree picker',
      //       link: '/demo/tree-picker',
      //       icon: 'offline_pin',
      //     },
      //     {
      //       label: 'Forms',
      //       link: '/demo/forms',
      //       icon: 'offline_pin',
      //     },
      //   ]
      // },
      {
        label: 'Gestión de Casilla Electrónica',
        link: '/casilla/gestion-casilla',
        icon: 'how_to_vote',
      },
      {
        label: 'Notificación Piloto',
        link: '/notificacion/gestion-notificacion-piloto',
        icon: 'notifications_active',
      }
      // ,
      // {
      //   label: 'Item 3',
      //   icon: 'offline_pin',
      //   onSelected: function () {
      //     console.log('Item 3');
      //   }
      // },
      // {
      //   label: 'Item 4',
      //   link: '/item-4',
      //   icon: 'star_rate',
      //   hidden: true
      // }
    ]
  };

  session: IAppSession = {
    isLoading: false,
    isLoggedIn: false,
    user: null,
    token: null,
    returnUrl: null,
    loginError: false,
    fromStorage: false,
    sessionExpired: false,
    displayUser: null
  };  

  globalConfig: IAppGlobalConfig = {
    isLoading: false,
    configuration: null,
    error: false
  };

}
